(function () {
  if (window.__scPdpAnalyticsLoaded) return;
  window.__scPdpAnalyticsLoaded = true;

  function publish(eventName, data) {
    if (
      window.Shopify &&
      Shopify.analytics &&
      typeof Shopify.analytics.publish === 'function'
    ) {
      Shopify.analytics.publish(eventName, data);
    }
  }

  function normalizeText(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function getMainProductInfo() {
    return document.querySelector('product-info[id^="MainProduct-"]');
  }

  /* =========================================
     PDP TAB OPENS
  ========================================= */

  document.addEventListener(
    'click',
    function (event) {
      const tab = event.target.closest('[role="tab"]');

      if (!tab || !tab.closest('custom-tabs')) return;

      const productInfo = getMainProductInfo();

      publish('saloncapes:pdp_tab_open', {
        product_id: productInfo?.dataset.standardProductId || '',
        product_handle: productInfo?.dataset.standardProductHandle || '',
        product_title: productInfo?.dataset.standardProductTitle || '',
        tab_id: tab.id || tab.getAttribute('aria-controls') || '',
        tab_label: normalizeText(tab.textContent),
        source_url: window.location.href
      });
    },
    true
  );

  /* =========================================
     PDP VARIANT / OPTION SELECTIONS
  ========================================= */

  document.addEventListener(
    'optionValueSelectionChange',
    function (event) {
      const target = event.detail?.target;
      const productInfo = getMainProductInfo();

      if (
        !target ||
        !productInfo ||
        event.detail?.sectionId !== productInfo.dataset.section
      ) {
        return;
      }

      let optionName = '';
      let optionValue =
        target.value ||
        target.dataset?.value ||
        target.textContent ||
        '';

      if (target.matches?.('input[type="radio"]')) {
        optionName = (target.name || '').replace(/-\d+$/, '');
      } else if (target.matches?.('option')) {
        const select = target.closest('select');

        optionName = (select?.name || '')
          .replace(/^options\[/, '')
          .replace(/\]$/, '');

        optionValue = target.value || target.textContent || '';
      } else {
        const fieldset = target.closest?.('fieldset');
        const legend = fieldset?.querySelector('legend');

        if (legend) {
          optionName = normalizeText(
            legend.childNodes[0]?.textContent || ''
          ).replace(/:$/, '');
        }
      }

      publish('saloncapes:pdp_variant_select', {
        product_id: productInfo.dataset.standardProductId || '',
        product_handle: productInfo.dataset.standardProductHandle || '',
        product_title: productInfo.dataset.standardProductTitle || '',
        option_name: normalizeText(optionName),
        option_value: normalizeText(optionValue),
        variant_id: '',
        source_url: window.location.href
      });
    },
    true
  );

  /* =========================================
     PDP GALLERY INTERACTIONS
  ========================================= */

  let scGalleryIntent = null;

  let scLastGalleryEvent = {
    mediaId: '',
    timestamp: 0
  };

  function publishGalleryInteraction(
    interactionType,
    mediaId,
    mediaPosition
  ) {
    const productInfo = getMainProductInfo();

    if (!productInfo) return;

    const now = Date.now();

    if (
      scLastGalleryEvent.mediaId === mediaId &&
      now - scLastGalleryEvent.timestamp < 500
    ) {
      return;
    }

    scLastGalleryEvent = {
      mediaId: mediaId,
      timestamp: now
    };

    publish('saloncapes:pdp_gallery_interaction', {
      product_id: productInfo.dataset.standardProductId || '',
      product_handle: productInfo.dataset.standardProductHandle || '',
      product_title: productInfo.dataset.standardProductTitle || '',
      interaction_type: interactionType || '',
      media_id: mediaId || '',
      media_position: mediaPosition || '',
      source_url: window.location.href
    });
  }

  document.addEventListener(
    'click',
    function (event) {
      const gallery = event.target.closest('media-gallery');

      if (!gallery) return;

      const thumbnail = event.target.closest(
        '[id^="GalleryThumbnails-"] [data-target]'
      );

      if (thumbnail) {
        publishGalleryInteraction(
          'thumbnail',
          thumbnail.dataset.target || '',
          thumbnail.dataset.mediaPosition || ''
        );

        scGalleryIntent = null;
        return;
      }

      const arrow = event.target.closest(
        '[id^="GalleryViewer-"] button[name="previous"], [id^="GalleryViewer-"] button[name="next"]'
      );

      if (arrow) {
        scGalleryIntent = {
          type: 'arrow',
          timestamp: Date.now()
        };
      }
    },
    true
  );

  document.addEventListener(
    'pointerdown',
    function (event) {
      const viewer = event.target.closest('[id^="GalleryViewer-"]');

      if (!viewer) return;

      if (
        event.target.closest(
          'button[name="previous"], button[name="next"]'
        )
      ) {
        return;
      }

      scGalleryIntent = {
        type: 'swipe',
        timestamp: Date.now()
      };
    },
    true
  );

  document.addEventListener(
    'slideChanged',
    function (event) {
      const viewer = event.target.closest?.('[id^="GalleryViewer-"]');

      if (!viewer || !scGalleryIntent) return;

      if (Date.now() - scGalleryIntent.timestamp > 2000) {
        scGalleryIntent = null;
        return;
      }

      const currentElement = event.detail?.currentElement;
      const mediaId = currentElement?.dataset?.mediaId || '';

      let mediaPosition = '';

      const gallery = viewer.closest('media-gallery');

      const thumbnail = gallery?.querySelector(
        `[data-target="${mediaId}"]`
      );

      if (thumbnail) {
        mediaPosition = thumbnail.dataset.mediaPosition || '';
      }

      publishGalleryInteraction(
        scGalleryIntent.type,
        mediaId,
        mediaPosition
      );

      scGalleryIntent = null;
    },
    true
  );

  /* =========================================
     PDP CONTENT CLICKS
  ========================================= */

  document.addEventListener(
    'pointerdown',
    function (event) {
      const link = event.target.closest('a[href]');

      if (!link) return;

      const insideTabs = link.closest('custom-tabs');
      const insideComplementary = link.closest('complementary-products');

      if (!insideTabs && !insideComplementary) return;

      const productInfo = getMainProductInfo();

      if (!productInfo) return;

      const href = link.href || '';
      const url = new URL(href, window.location.origin);
      const pathname = url.pathname.toLowerCase();

      let destinationType = 'internal_content';

      if (url.origin !== window.location.origin) {
        destinationType = 'external';
      } else if (pathname.includes('/products/')) {
        destinationType = 'product';
      } else if (pathname.includes('/collections/')) {
        destinationType = 'collection';
      } else if (
        pathname.includes('/blogs/') ||
        pathname.includes('buying-guide') ||
        pathname.includes('buying_guides')
      ) {
        destinationType = 'buying_guide';
      } else if (
        pathname.includes('warranty') ||
        pathname.includes('shipping') ||
        pathname.includes('returns')
      ) {
        destinationType = 'support';
      }

      publish('saloncapes:pdp_content_click', {
        product_id: productInfo.dataset.standardProductId || '',
        product_handle: productInfo.dataset.standardProductHandle || '',
        product_title: productInfo.dataset.standardProductTitle || '',
        link_text:
          normalizeText(link.textContent) ||
          normalizeText(link.getAttribute('aria-label')) ||
          '',
        destination_type: destinationType,
        destination_url: href,
        content_area: insideTabs ? 'pdp_tabs' : 'complementary_products',
        source_url: window.location.href
      });
    },
    true
  );

  /* =========================================
     PDP PRODUCT RECOMMENDATION CLICKS
  ========================================= */

  document.addEventListener(
    'click',
    function (event) {
      const link = event.target.closest(
        'product-recommendations .card__heading--product a[href]'
      );

      if (!link) return;

      const productInfo = getMainProductInfo();
      const card = link.closest('.card-wrapper--product');
      const recommendationItem = link.closest('.grid__item');
      const recommendationList = recommendationItem?.closest(
        '.recommendation-list'
      );

      if (!productInfo || !card || !recommendationItem) return;

      let selectedColor = '';

      const optionControls = productInfo.querySelectorAll(
        'input[name], select[name]'
      );

      for (const control of optionControls) {
        const optionName = (control.name || '').toLowerCase();

        if (!optionName.includes('color')) continue;

        if (
          control.matches('input[type="radio"]') &&
          !control.checked
        ) {
          continue;
        }

        selectedColor = normalizeText(control.value || '');
        break;
      }

      let recommendationPosition = '';

      if (recommendationList) {
        const recommendationItems = Array.from(
          recommendationList.children
        );

        const index = recommendationItems.indexOf(
          recommendationItem
        );

        if (index >= 0) {
          recommendationPosition = index + 1;
        }
      }

      const destinationUrl = new URL(
        link.href,
        window.location.origin
      );

      const pathParts = destinationUrl.pathname
        .split('/')
        .filter(Boolean);

      let recommendedProductHandle = '';

      const productPathIndex = pathParts.indexOf('products');

      if (
        productPathIndex >= 0 &&
        pathParts[productPathIndex + 1]
      ) {
        recommendedProductHandle =
          pathParts[productPathIndex + 1];
      }

      const recommendedProductTitle = normalizeText(
        card.querySelector('.card__heading__product-title')
          ?.textContent || ''
      );

      publish('saloncapes:pdp_recommendation_click', {
        product_id:
          productInfo.dataset.standardProductId || '',
        product_handle:
          productInfo.dataset.standardProductHandle || '',
        product_title:
          productInfo.dataset.standardProductTitle || '',
        content_area: 'product_recommendations',
        option_value: selectedColor,
        recommended_product_handle:
          recommendedProductHandle,
        recommended_product_title:
          recommendedProductTitle,
        recommendation_position:
          recommendationPosition,
        coordinated_color:
          card.dataset.scCoordinatedColor || '',
        destination_url: link.href || '',
        source_url: window.location.href
      });
    },
    true
  );

})();